import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

const selectUserSettingsStore = ({ userSettings }) => userSettings;

const makeSelectUserSettings = () => createSelector(
  selectUserSettingsStore,
  ({ settings }) => settings,
);

const makeSelectUserReferences = () => createSelector(
  selectUserSettingsStore,
  (state) => state[GC.UI_FIELD_REFERENCES],
);

const makeSelectUserRoles = () => createSelector(
  selectUserSettingsStore,
  ({ roles }) => roles,
);

const makeSelectUserSettingsFields = () => createSelector(
  selectUserSettingsStore,
  ({ fields }) => fields,
);

const makeSelectCurrentUserSettingsFields = () => createSelector(
  selectUserSettingsStore,
  ({ currentUserSettings }) => currentUserSettings,
);

const makeSelectPinnedBranches = () => createSelector(
  selectUserSettingsStore,
  (state) => R.pathOr([], ['currentUserSettings', GC.PINNED_BRANCHES_GUIDS], state),
);

const makeSelectPinnedMenuItems = () => createSelector(
  selectUserSettingsStore,
  (state) => R.pathOr([], ['currentUserSettings', 'pinnedMenuItems'], state),
);

const makeSelectSortedByNamePinnedBranches = () => createSelector(
  selectUserSettingsStore,
  (state) => R.compose(
    R.sortBy(R.compose(R.toLower, R.prop(GC.BRANCH_NAME))),
    R.filter(G.isNotNil),
    R.map(G.getBranchFromWindowByGuid),
    R.pathOr([], ['currentUserSettings', GC.PINNED_BRANCHES_GUIDS]),
  )(state),
);

const makeSelectAvailableByUserTypeRoleList = () => createSelector(
  selectUserSettingsStore,
  ({ availableByUserTypeRoleList }) => availableByUserTypeRoleList,
);

export {
  makeSelectUserRoles,
  makeSelectUserSettings,
  selectUserSettingsStore,
  makeSelectUserReferences,
  makeSelectPinnedBranches,
  makeSelectPinnedMenuItems,
  makeSelectUserSettingsFields,
  makeSelectCurrentUserSettingsFields,
  makeSelectSortedByNamePinnedBranches,
  makeSelectAvailableByUserTypeRoleList,
};
